import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Input } from 'antd';

import CountryInput from './CountryInput';
import { Form } from '~/components';

type InputsType = 'country' | 'postalCode' | 'region' | 'city' | 'cityLocalized' | 'addressLine';

interface Props {
  source?: string;
  excludeInputs?: InputsType[];
}

const AddressInputGroup: FC<Props> = (props) => {
  const { source = 'address', excludeInputs = [] } = props;
  const [t] = useTranslation();

  const isExcluded = (key: InputsType): boolean => {
    const res = excludeInputs.indexOf(key);
    return res !== -1;
  };

  return (
    <>
      {!isExcluded('country') && (
        <Form.Item name={[source, 'country']} label={t('country')} rules={[{ required: true }]}>
          <CountryInput />
        </Form.Item>
      )}
      {!isExcluded('postalCode') && (
        <Form.Item
          name={[source, 'postalCode']}
          label={t('postalCode')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      )}
      {!isExcluded('region') && (
        <Form.Item name={[source, 'region']} label={t('region')}>
          <Input />
        </Form.Item>
      )}
      {!isExcluded('country') && !isExcluded('cityLocalized') ? (
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name={[source, 'city']} label={t('city')}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name={[source, 'cityLocalized']} label={t('cityLocalized')}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
      ) : (
        <>
          {!isExcluded('city') && (
            <Form.Item name={[source, 'city']} label={t('city')}>
              <Input />
            </Form.Item>
          )}
          {!isExcluded('cityLocalized') && (
            <Form.Item name={[source, 'cityLocalized']} label={t('cityLocalized')}>
              <Input />
            </Form.Item>
          )}
        </>
      )}
    </>
  );
};

export default AddressInputGroup;
